import React from "react";

const RadioButton = ({ id, name, label, value, onChange, checked, required }) => (
  <label
    htmlFor={id}
    style={{
      display: "flex",
      alignItems: "flex-start",
      gap: "0.75rem",
      backgroundColor: checked ? "rgba(0,68,127,0.08)" : "#ffffff",
      border: checked ? "1.5px solid #00447f" : "1.5px solid #e2e4ea",
      borderRadius: "0.5rem",
      padding: "0.875rem 1.25rem",
      cursor: "pointer",
      marginBottom: "0.5rem",
    }}
  >
    <input
      type="radio"
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      checked={checked}
      required={required}
      style={{
        accentColor: "#00447f",
        width: 18,
        height: 18,
        flexShrink: 0,
        marginTop: 2,
        cursor: "pointer",
      }}
    />
    <span style={{ fontSize: "0.9rem", color: "#181c23", lineHeight: 1.5 }}>{label}</span>
  </label>
);

export default RadioButton;
